import React, { useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  IconButton,
} from "@mui/material";
import toast from "react-hot-toast";

export default function DeletePaymentMethod({ isPaymentLinked, className, style }) {
  const userId = localStorage.getItem("logged_user_id");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const deletePaymentMethodFromBackend = async () => {
    setIsDeleting(true);
    try {
      const res = await fetch(
        "https://chefrepublicwebapi-dev.portalwiz.in/api/user/delete_chef_account",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ user_id: userId }),
        }
      );

      let data = {};
      try {
        data = await res.json();
      } catch (jsonErr) {
        console.error("❌ Error parsing JSON response:", jsonErr);
        toast.error("Error processing server response.");
        return;
      }

      if (res.ok && data.status === true) {
        alert("✅ Your PayPal Account has been disconnected from Chef Republic.");
        setShowDeleteDialog(false);

        setTimeout(() => {
          console.log("🔄 Refreshing page...");
          window.location.reload();
        }, 1000);
      } else {
        console.error("❌ Failed to delete payment method!", data?.message);
        toast.error(data?.message || "❌ Failed to delete payment method!");
      }
    } catch (err) {
      console.error("❌ Delete payment method error:", err);
      toast.error("Failed to delete payment method. Please try again.");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Box>
      {/* Delete Button */}
      <button
        type="button"
        className={className || "btn btn-orange rounded-pill mb-3"}
        disabled={!isPaymentLinked}
        onClick={() => setShowDeleteDialog(true)}
        style={{
          width: "100%",
          letterSpacing: "0.5px",
          backgroundColor: !isPaymentLinked ? "#cccbcbff" : "#FF5E41",
          color: "#fff",
          opacity: 1,
          cursor: !isPaymentLinked ? "not-allowed" : "pointer",
          ...style,
        }}
      >
        <span>&nbsp;&nbsp;&nbsp;&nbsp;Delete Payment Method&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </button>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={showDeleteDialog}
        onClose={() => !isDeleting && setShowDeleteDialog(false)}
        PaperProps={{
          sx: {
            width: "400px",
            borderRadius: "15px",
            maxWidth: "90vw",
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Delete Payment Method
            </Typography>
            <IconButton
              onClick={() => setShowDeleteDialog(false)}
              disabled={isDeleting}
              sx={{ color: "#666" }}
            >
              ✕
            </IconButton>
          </Box>

          <Typography variant="body1" sx={{ mb: 2, color: "#666"  }}>
            Disconnecting your PayPal account will prevent you from offering PayPal
            services and products on Chef Republic.
          </Typography>

          <Typography
            variant="body1"
            sx={{ mb: 3, color: "#666"}}
          >
            Do you wish to continue?
          </Typography>

          <Box sx={{ display: "flex", }}>
            {/* <button
              onClick={() => setShowDeleteDialog(false)}
              disabled={isDeleting}
              className="btn btn-outline-secondary rounded-pill"
              style={{
                width: "100%",
                border: "1px solid #ddd",
                color: "#666",
                backgroundColor: "#fff",
              }}
            >
              Cancel
            </button> */}
            <button
              disabled={isDeleting}
              onClick={deletePaymentMethodFromBackend}
              className="btn btn-orange rounded-pill"
              style={{
                width: "100%",
                opacity: isDeleting ? 0.6 : 1,
                cursor: isDeleting ? "not-allowed" : "pointer",
              }}
            >
              {isDeleting ? "Deleting..." : "Yes, Delete"}
            </button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
